module.exports = __webpack_public_path__ + "img/icon-excel.c573f264.svg";